import { render, staticRenderFns } from "./HeaderFyF.vue?vue&type=template&id=512dbfa4"
import script from "./HeaderFyF.vue?vue&type=script&lang=js"
export * from "./HeaderFyF.vue?vue&type=script&lang=js"
import style0 from "./HeaderFyF.vue?vue&type=style&index=0&id=512dbfa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports